import React from 'react';
import './dashboard.css';
import { ChartContainer } from '../../Components/ChartContainer/ChartContainer';

export default function Dashboards() {
  return <ChartContainer />;
}
